export type FifoSide = 'buy' | 'sell';

export type FifoExecution = {
  side: FifoSide;
  qty: number;
  price: number;
};

export type OpenLot = {
  price: number;
  qty: number;
};

export type FifoPnlResult = {
  grossPnl: number;
  matchedQty: number;
  openLongLots: OpenLot[];
  openShortLots: OpenLot[];
};

export function calculateFifoGrossPnl(executions: FifoExecution[]): FifoPnlResult {
  const openLongLots: OpenLot[] = [];
  const openShortLots: OpenLot[] = [];
  let grossPnl = 0;
  let matchedQty = 0;

  for (const execution of executions) {
    const side = execution.side;
    let remainingQty = Math.max(0, Number(execution.qty) || 0);
    const executionPrice = Number(execution.price);

    if (!remainingQty || !Number.isFinite(executionPrice)) continue;

    if (side === 'sell') {
      while (remainingQty > 0 && openLongLots.length > 0) {
        const lot = openLongLots[0];
        const matched = Math.min(remainingQty, lot.qty);
        grossPnl += (executionPrice - lot.price) * matched;
        matchedQty += matched;
        lot.qty -= matched;
        remainingQty -= matched;
        if (lot.qty <= 0) openLongLots.shift();
      }

      if (remainingQty > 0) {
        openShortLots.push({ price: executionPrice, qty: remainingQty });
      }
      continue;
    }

    while (remainingQty > 0 && openShortLots.length > 0) {
      const lot = openShortLots[0];
      const matched = Math.min(remainingQty, lot.qty);
      grossPnl += (lot.price - executionPrice) * matched;
      matchedQty += matched;
      lot.qty -= matched;
      remainingQty -= matched;
      if (lot.qty <= 0) openShortLots.shift();
    }

    if (remainingQty > 0) {
      openLongLots.push({ price: executionPrice, qty: remainingQty });
    }
  }

  return {
    grossPnl,
    matchedQty,
    openLongLots,
    openShortLots,
  };
}
